import React, { useState } from 'react';
import { fromApi } from '../../common/models/user';
import useFetchUserAssets from '../../assets/hooks/useFetchUserAssets';
import { LeftSection } from './LeftSection';
import { ProfileLayout } from '../components/ProfileLayout';
import { MiddleSection } from './MiddleSection';
import { RightSection } from './RightSection';
import useGetCategories from '../../common/hooks/useGetCategories';
import useSuapContract from '../hooks/useSuapContract';
import { getCategoryLabelsFromValues } from '../../common/utils';
import useUserFetchProfile from '../hooks/useUserFetchProfile';
import { MobileProfilePage } from './MobileProfilePage';
import FORMAT_SIZES from '../../common/constants/FormatSizes';
import { THEME_COLORS } from '../../common/colors';

export default function ProfileView(props) {
  const { format, match, userInfo } = props;
  const { userInfo: user } = useUserFetchProfile({
    uuid: match.params.username,
  });
  const { userAssets } = useFetchUserAssets(user);
  const { categories, loading: loadingCategories } = useGetCategories();
  const isCurrentUser = userInfo.id === user.id;

  const { contractDetails, suapMetrics } = useSuapContract(user.uuid);

  const userLookingForList = getCategoryLabelsFromValues(
    categories,
    user.topcategories,
  );

  if (format === FORMAT_SIZES.MOBILE) {
    return (
      <MobileProfilePage
        suapMetrics={suapMetrics}
        type="public"
        user={user}
        userLookingForList={userLookingForList}
        contractDetails={contractDetails}
        categories={categories}
        userAssets={userAssets}
        isCurrentUser={isCurrentUser}
        userInfo={userInfo}
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#f4f5f4' }}>
      <div
        style={{
          maxWidth: '600px',
          margin: '0 auto',
          backgroundColor: '#fff',
          position: 'relative',
          boxShadow:
            'box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;',
        }}
      >
        <MobileProfilePage
          suapMetrics={suapMetrics}
          type="public"
          user={user}
          userLookingForList={userLookingForList}
          contractDetails={contractDetails}
          categories={categories}
          userAssets={userAssets}
          isCurrentUser={isCurrentUser}
          userInfo={userInfo}
        />
      </div>
    </div>
  );
}
